"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tabs = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactPose = _interopRequireWildcard(require("react-pose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TabContainer = _interopRequireDefault(require("./TabContainer"));

var _Tab = _interopRequireDefault(require("./Tab"));

var _TabPanel = _interopRequireDefault(require("./TabPanel"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = {};
var CHANGE_TAB = 'CHANGE_TAB';

var tabReducer = function tabReducer(state, action) {
  switch (action.type) {
    case CHANGE_TAB:
      {
        return _objectSpread({}, state);
      }

    default:
      {
        return state;
      }
  }
};

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var _React$useReducer = _react.default.useReducer(tabReducer, []),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      tabState = _React$useReducer2[0],
      dispatchTabState = _React$useReducer2[1];

  var NavTabs = _react.default.Children(children, function (child) {
    var childProps = child.props;
    return _react.default.createElement(_Tab.default, {
      key: childProps.key
    }, "Hello world");
  });

  var TabPanels = _react.default.Children(children, function (child) {
    var childProps = child.props;
    return _react.default.createElement(_TabPanel.default, {
      path: childProps.key
    }, "Hello world");
  });

  return _react.default.createElement(_reactRouterDom.MemoryRouter, {
    initialEntries: ['/'],
    initialIndex: 0
  }, _react.default.createElement(_TabContainer.default, {
    component: props.tabContainer
  }, NavTabs), _react.default.createElement(Route, {
    render: function render(_ref2) {
      var location = _ref2.location;
      return _react.default.createElement(_reactPose.PoseGroup, null, _react.default.createElement(RouteContainer, {
        key: location.key
      }, _react.default.createElement(Switch, {
        location: location
      }, TabPanels)));
    }
  }));
};

exports.Tabs = Tabs;
Tabs.defaultProps = {
  children: [],
  tabContainer: 'div'
};

var Tab = function Tab(props) {
  return children;
};

var _default = Tabs;
exports.default = _default;